import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const CASH_DRAWER_REPORT = gql`
  mutation CashDrawerReportMutation($eventId: Int!) {
    getPOSRegisterReport(event_id: $eventId) {
      cash
      card
      num_transactions
      num_tickets
      total_revenue
      ticket_breakdown_data {
        name
        price
        qty
        total
      }
      user {
        formatted_name
      }
      event {
        id
        logo
        name
        start_date
        end_date
        eventDates
        isMultiDay
        listDates
        day
        date
        fullDate
        month
        status
        track {
          id
          logo
          name
        }
        series {
          id
          name
        }
        account_name
      }
    }
  }
`;

export function useGetCashDrawerReport() {
  const [cashDrawerMutation] = useMutation(CASH_DRAWER_REPORT);
  const result = useCallback(
    (eventId) => {
      return cashDrawerMutation({
        variables: {
          eventId: Number(eventId),
        },
      });
    },
    [cashDrawerMutation]
  );
  return result;
}
